import { render } from "./homeMentality.vue?vue&type=template&id=e0ea43bc&scoped=true"
import script from "./homeMentality.vue?vue&type=script&lang=js"
export * from "./homeMentality.vue?vue&type=script&lang=js"

import "./homeMentality.vue?vue&type=style&index=0&id=e0ea43bc&lang=scss&scoped=true"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0ea43bc"]])

export default __exports__